import { useEffect } from 'react'
import { useQuery } from '@apollo/client';
import LogoWhite from '../../img/sa-enkelt-logo-white.svg';
import CityLogo from '../../img/city-logo-2.svg';
import ExampleCoupons from '../../img/example-coupons.png';
import { useNavigationContext } from '../../context/NavigationContext';
import { getCompanyTypesQuery } from '../../queries/company';
import { companyStatsByTokenQuery } from '../../queries/bookletCompanyReview';
import CompanyStatsCoupons from './CompanyStatsCoupons';

const { REACT_APP_BRAND } = process.env;
function CompanyStats(props) {
  const { token } = props.match.params;
  const { setNavigationActivated } = useNavigationContext();
  const { data: companyTypesData } = useQuery(getCompanyTypesQuery);
  const { data: companyStatsData, loading: companyStatsLoading, error: companyStatsError, refetch: refetchStats } = useQuery(companyStatsByTokenQuery, { variables: { token: token } });

  useEffect(() => {
    setNavigationActivated(false);
  }, []);

  if (companyStatsLoading) return null;
  if (companyStatsError) {
    console.log('Error', companyStatsError);
  }

  const booklet = companyStatsData.companyStatsByToken.booklet;
  const now = new Date();

  const isBookletLive =
    (!booklet.validFrom || new Date(booklet.validFrom) <= now) &&
    (!booklet.validTo || new Date(booklet.validTo) >= now);

  const headerMessage = isBookletLive
    ? 'Följ i realtid hur dina kuponger används och se vilka erbjudanden som fungerar bäst. ' +
    'Längre ner hittar du tips och råd som kan hjälpa dig få ännu fler aktiveringar, nu och framåt.'
    : 'Här hittar du statistik över hur dina kuponger användes under häftesperioden. ' +
    'Längre ner hittar du tips och råd som kan hjälpa dig få ännu fler aktiveringar i framtiden!';

  return (
    <div id="company-review" className='flex flex-col items-center'>
      <header className={`flex flex-col justify-center items-center ${REACT_APP_BRAND === 'SAENKELT' ? 'saenkelt' : ''}`}>
        <img src={REACT_APP_BRAND === 'CITY' ? CityLogo : LogoWhite} alt={REACT_APP_BRAND === 'CITY' ? 'City Logo' : 'Så Enkelt Logo'} />
      </header>
      {!companyStatsError
        ? <>
          <div className='relative company-review-content flex flex-col items-center'>
            <h2 className='bold'>Inlösenstatistik</h2>
            <p>{headerMessage}</p>
            <div className="company-review-apps flex">
              <CompanyStatsCoupons
                companyStatsData={companyStatsData}
                companyTypesData={companyTypesData}
              />
            </div>
          </div>
        </>
        : <div className='relative company-review-content flex flex-col items-center'>
          <h2>Något gick fel</h2>
          <p>Vi kunde inte hitta någon statistik med den angivna länken.</p>
        </div>
      }

      <div className='help-card flex flex-col'>
        <h3>3 tips för att öka inlösen av era erbjudanden</h3>

        <h4>Synlighet och medvetenhet i butiken</h4>
        <p>Påminn personalen om vilka erbjudanden som finns i häftet. Säljer ni värdebevis? Ha dem synliga i kassan.</p>


        <h4>Aktiv guidning - vid rätt tillfälle</h4>
        <p>Erbjudanden fungerar ofta bäst när personalen nämner dem aktivt. Särskilt vid tydliga köptillfällen som lunch, helg eller säsongstart.</p>

        <h4>Testa, jämför och lär</h4>
        <p>Olika typer av erbjudanden ger olika resultat. Använd statistiken för att se vad som fungerar bäst inför nästa period.</p>
      </div>

      <div className='help-card flex flex-col'>
        <div className='flex justify-between'>
          <div className='flex flex-col text'>
            <h3>Vilken typ av kuponger fungerar bäst?</h3>
            <h4>Korta och tydliga erbjudanden</h4>
            <p>Kunden ska direkt förstå erbjudandet. Undvik därför krångliga villkor.</p>

            <h4>Öppna och tillgängliga erbjudanden</h4>
            <p>Exempelvis</p>
            <ul>
              <li>25% på valfri vara</li>
              <li>100 kr rabatt vid köp över 500 kr</li>
              <li>2 för 1 på lunch</li>
            </ul>
            <p>Valfri vara ger kunden frihet och ökar chansen till köp. Rabatt vid köp över viss summa kan leda till att kunden handlar lite mer. 2 för 1 gör det lätt att ta med någon annan – och kan ge nya återkommande kunder.</p>

            <h4>Undvik spetsiga erbjudanden</h4>
            <p>Erbjudanden som endast tilltalar få kan irritera och sänka helhetsintrycket av häftet.</p>
          </div>

          <img src={ExampleCoupons} alt='Exempel kuponger' />
        </div>
      </div>

      {isBookletLive && (
        <div className='help-card dark flex flex-col'>
          <h3>Vill du lägga till en kupong under perioden?</h3>

          <p>Det är möjligt att komplettera med fler erbjudanden under pågående period, så länge det inte innebär ändringar i redan beslutade kuponger.</p>

          <ul>
            <li>Fånga säsonger eller kampanjer</li>
            <li>Testa nytt</li>
            <li>Skapa mer synlighet</li>
          </ul>

          <p>Kontakta <a href='mailto:info@cityhaftet.se'>info@cityhaftet.se</a> om du vill lägga till något.</p>
        </div>
      )}

    </div>
  )
}

export default CompanyStats
